import { actionCreator, ActionReturnType } from "@itk/typescript-utils";
import { Shared_PictureResolutions } from "src/backend/openapi/v1";

export enum Action {
  GetContactPersonPictureRequest = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:PROFILE-SETTINGS:PROFILE-SETTINGS-STORE.TS:ACTION:GETCONTACTPERSONPICTUREREQUEST",

  SetIsProfilePictureDialogOpen = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:PROFILE-SETTINGS:PROFILE-SETTINGS-STORE.TS:ACTION:SETISPROFILEPICTUREDIALOGOPEN",

  postContactPersonPictureRequst = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:PROFILE-SETTINGS:PROFILE-SETTINGS-STORE.TS:ACTION:POSTCONTACTPERSONPICTUREREQUST",

  deleteContactPersonPictureRequest = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:PROFILE-SETTINGS:PROFILE-SETTINGS-STORE.TS:ACTION:DELETECONTACTPERSONPICTUREREQUEST",

  Clear = "@@ITK:SRC:PAGES:PROFILE:COMPONENTS:PROFILE-SETTINGS:PROFILE-SETTINGS-STORE.TS:ACTION:CLEAR"
}

type profileSettingsState = {
  isProfilePictureDialogOpen: boolean;
};

const initialState: profileSettingsState = {
  isProfilePictureDialogOpen: false
};

export const profileSettingsActions = {
  setIsProfilePictureDialogOpen: (data: boolean) => actionCreator(Action.SetIsProfilePictureDialogOpen, { data }),

  getContactPersonPictureRequest: (contactPersonId: string, resolution: Shared_PictureResolutions, callBack: (isSuccess: boolean, picture?: string) => void) =>
    actionCreator(Action.GetContactPersonPictureRequest, { contactPersonId, resolution, callBack }),

  postContactPersonPictureRequest: (contactPersonId: string, file: File) => actionCreator(Action.postContactPersonPictureRequst, { contactPersonId, file }),

  deleteContactPersonPictureRequest: (contactPersonId: string) => actionCreator(Action.deleteContactPersonPictureRequest, { contactPersonId }),

  clear: () => actionCreator(Action.Clear)
};

export const profileSettingsReducer = (state = initialState, action: ActionReturnType<typeof profileSettingsActions>): profileSettingsState => {
  switch (action.type) {
    case Action.SetIsProfilePictureDialogOpen:
      return { ...state, isProfilePictureDialogOpen: action.payload.data };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
